module.exports = __webpack_public_path__ + "img/registration-3000.e34693c3.png";